import ToastWrap from "PFComponents/growl/toast";
import TrashIcon from "PFIcons/trash.svg";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const useActivityPageCompare = (taskId, tabActiveId) => {
  const history = useHistory();
  const [compareIds, setCompreIds] = useState({});
  const { t } = useTranslation("activities");

  const clearComparisonToast = useCallback(() => setCompreIds({}), []);

  const keys = Object.keys(compareIds);
  const len = keys.length;
  const comparisonLocation = {
    pathname: `/activities/${taskId}/compare/details/${keys.join(",")}`,
    state: { prevPath: location.pathname }
  };

  const comparisonToastWrapp = (
    <ToastWrap
      show={len > 0}
      text={len > 1 ? t("show.countProfilesAdded", { count: len }) : t("show.selectOneProfile")}
      action={len > 1 ? () => history.push(comparisonLocation) : null}
      actionText={t("show.compareNow")}
      icon={<TrashIcon width={14} height={14} />}
      iconAction={clearComparisonToast}
    />
  );

  useEffect(() => {
    if (tabActiveId !== "shortlist" && Object.keys(compareIds).length > 0) {
      setCompreIds({});
    }
  }, [compareIds, tabActiveId]);

  const isProfileInComparison = useCallback((profileId) => !!compareIds[profileId], [compareIds]);

  const addProfileToComparison = useCallback(
    (profileId) => setCompreIds({ ...compareIds, [profileId]: true }),
    [compareIds]
  );

  const removeProfileFromComparison = useCallback(
    (profileId) => {
      delete compareIds[profileId];
      setCompreIds({ ...compareIds });
    },
    [compareIds]
  );

  return {
    comparisonToastWrapp,
    isProfileInComparison,
    addProfileToComparison,
    removeProfileFromComparison,
    clearComparisonToast
  };
};

export default useActivityPageCompare;
